const TOKEN_KEY = 'token';
const USER_INFO_KEY = 'userInfo';
const IMPERSONATION_SESSION_KEY = 'impersonationSession';

/** 탭/창 단위 세션 — 탭을 닫으면 JWT·사용자 정보가 함께 제거됨 */
const authStorage = () => sessionStorage;

let legacyLocalAuthCleared = false;

/** 이전 localStorage 기반 로그인 잔여 데이터 제거 (1회) */
export function clearLegacyLocalAuth() {
  if (legacyLocalAuthCleared) {
    return;
  }
  legacyLocalAuthCleared = true;
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_INFO_KEY);
  } catch {
    // ignore
  }
}

export function getAuthToken() {
  return authStorage().getItem(TOKEN_KEY);
}

export function setAuthToken(token) {
  authStorage().setItem(TOKEN_KEY, token);
}

export function getUserInfoRaw() {
  return authStorage().getItem(USER_INFO_KEY);
}

export function setUserInfoRaw(json) {
  authStorage().setItem(USER_INFO_KEY, json);
}

export function clearAuthStorage() {
  authStorage().removeItem(TOKEN_KEY);
  authStorage().removeItem(USER_INFO_KEY);
  authStorage().removeItem(IMPERSONATION_SESSION_KEY);
}

export function hasAuthToken() {
  return !!getAuthToken();
}

export function isImpersonationSession() {
  return authStorage().getItem(IMPERSONATION_SESSION_KEY) === 'true';
}

/**
 * 대리 로그인: /impersonate-session#token=... 에서 JWT를 sessionStorage에 적용.
 * window.open 새 창이 opener의 sessionStorage(OP 세션)를 복제해도 hash 토큰이 우선한다.
 * @returns {boolean} 토큰을 적용했으면 true
 */
export function consumeImpersonateTokenFromUrl() {
  if (typeof window === 'undefined') {
    return false;
  }
  if (window.location.pathname !== '/impersonate-session') {
    return false;
  }
  try {
    const rawHash = window.location.hash.startsWith('#')
      ? window.location.hash.slice(1)
      : window.location.hash;
    const token = new URLSearchParams(rawHash).get('token');
    if (!token) {
      return false;
    }
    clearAuthStorage();
    setAuthToken(token);
    authStorage().setItem(IMPERSONATION_SESSION_KEY, 'true');
    window.history.replaceState(null, '', '/impersonate-session');
    return true;
  } catch {
    return false;
  }
}
